import { render, staticRenderFns } from "./CommunityGroupShow.vue?vue&type=template&id=02c8122a&scoped=true&"
import script from "./CommunityGroupShow.vue?vue&type=script&lang=js&"
export * from "./CommunityGroupShow.vue?vue&type=script&lang=js&"
import style0 from "./CommunityGroupShow.vue?vue&type=style&index=0&id=02c8122a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c8122a",
  null
  
)

export default component.exports